export default __webpack_public_path__ + "static/media/Bullhorn.140ce059.svg";